import { render, staticRenderFns } from "./search-duration.vue?vue&type=template&id=64a701e5&scoped=true&"
import script from "./search-duration.vue?vue&type=script&lang=js&"
export * from "./search-duration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a701e5",
  null
  
)

export default component.exports